/* eslint-disable camelcase */
import axios from '@axios'

export const state = {
  drafts: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}
export const getters = {
  allDrafts: (state) => state.drafts,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalDraft: (state) => state.totalDraft,
  totalRecords: (state) => state.totalRecords,
}
export const mutations = {
  GET_DRAFTS: (state, data) => {
    if (!data) return false
    state.drafts = Array.isArray(data.campaigns) ? data.campaigns : []
    state.currentPage =
      typeof data.page === 'number' ? data.page : state.currentPage
    state.perPage =
      typeof data.perPage === 'number' ? data.perPage : state.perPage
    state.totalPages =
    typeof data.totalPages === 'number' ? data.totalPages : state.totalPages
    state.totalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.totalRecords
  },
  CREATE_DRAFT: (state, draft) => {
    state.drafts.unshift(draft)
  },
  UPDATE_DRAFT: (state, editedDraft) => {
    state.drafts = state.drafts.filter((draft) => draft.id !== editedDraft.id)
    state.drafts.unshift(editedDraft)
  },
  REMOVE_DRAFT: (state, deletedDraft) => {
    state.drafts = state.drafts.filter((draft) => draft.id !== deletedDraft.id)
  },
  SEND_DRAFT: (state, sentDraft) => {
    state.drafts = state.drafts.filter((draft) => draft.id !== sentDraft.id)
  },
}

export const actions = {
  async getDrafts({ commit, dispatch }, params = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    params = { ...params, ...{ type: 'draft' } }
    await axios
      .get(`/sms/campaigns`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = resp.data
          commit('GET_DRAFTS', data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_DRAFT', null)
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async getDraft({ dispatch }, id) {
    return axios.get(`/sms/campaigns/${id}`)
  },
  async getRecipientByCampaignId({ dispatch }, { draft, paginate }) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${draft.id}/recipients`, {
      params: paginate,
    })
  },
  async createDraft({ commit }, campaign) {
    campaign.type = 'draft'
    return axios.post(`/sms/campaigns`, campaign)
  },
  async decryptCampaign({ dispatch }, campaign) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${campaign.id}/decode`)
  },
  async encryptCampaign({ commit }) {
    commit('GET_CAMPAIGNS', null)
  },

  async calculatePrice({ dispatch }, campaign) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.post('/sms/campaigns/estimate', campaign)
  },
//  async saveDraft(draft) {
//     for (let field in draft) {
//       if (field === 'recipients') {
//         let recipients = []
//         draft.recipients.forEach((r) => recipients.push(r.number))
//         form.append(field, recipients)
//         continue
//       }
//       form.append(field, draft[field])
//     } 
//     return axios.post(`/sms/campaigns/draft`, )
//   },
async saveCampaign({ commit, dispatch }, campaign) {
  // overwriting the campaign type to draft
  campaign.type = 'draft'

  return axios.post(`/sms/campaigns`, campaign)
},
  async sendDraft({ commit }, draft) {
    await axios.post(`/sms/campaigns/${draft.id}/send`).then((resp) => {
      if (resp.status === 200) {
        commit('SEND_DRAFT', draft)
      }
    })
  },
  async removeDraft({ commit, dispatch }, draft) {
    dispatch('layout/changeLoading', true, { root: true })
    await axios.delete(`/sms/campaigns/${draft.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_DRAFT', draft)
        dispatch('layout/changeLoading', false, { root: true })
      }
    })
  },
  async updateDraft({ commit }, draft) {
    await axios.put(`/sms/campaigns`, draft).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_DRAFT', resp.data)
      }
    })
  },
  async importCampaign({ dispatch }, file) {
    dispatch('layout/changeLoading', true, { root: true })
    let form = new FormData()
    form.append('file', file)
    return axios.post('/sms/campaigns/import', form)
  },
  async exportCampaign({ campaign, params }) {
    return axios.post(`/sms/campaign/export/${campaign.id}`, params)
  },
}
